import React from "react";
import styles from "styles/component/NoItemFound.module.scss";
import asset from "json/assets";
import CustomButton from "ui/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

 function PageNotFound() {
  const navigate = useNavigate()

  const redirectToHome =()=>{
    navigate(-1)
  }
  return (
    <div className={styles.not_found_container}>
    <div className={styles.not_found_cont}>
      <figure>
          <img src={asset.PageNotFound} alt="" />
      </figure>
      <CustomButton type='button' onClick={redirectToHome}>Back To Home</CustomButton>
    </div>
  </div>
  );
}
export default PageNotFound;